import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { router } from './routes';
import '@/app/globals.css';

const GA_ID = import.meta.env.VITE_GA_ID || 'G-XXXXXXXXXX';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="treina-theme">
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>
);
